import { defineMessages } from "react-intl";

export const messages = defineMessages({
  predictionHeader: {
    id: "RgbSliderQuestion.predictionHeader",
    defaultMessage: "Prediction Question",
    description: "Header label shown when the question is in prediction mode.",
  },
  defaultQuestion: {
    id: "RgbSliderQuestion.defaultQuestion",
    defaultMessage:
      "Every color on your screen is just a mix of red, green and blue. Adjust the sliders to match the ‘Target Color.’",
    description: "Default prompt shown above the RGB sliders.",
  },
  instructionText: {
    id: "RgbSliderQuestion.instructionText",
    defaultMessage: "(Use the slider to adjust your color.)",
    description: "Helper text shown beneath the question prompt.",
  },
  targetColorLabel: {
    id: "RgbSliderQuestion.targetColorLabel",
    defaultMessage: "Target color",
    description: "Label for the fixed target color swatch.",
  },
  yourColorLabel: {
    id: "RgbSliderQuestion.yourColorLabel",
    defaultMessage: "Your color",
    description: "Label for the learner's live color swatch.",
  },
  targetColorSwatchLabel: {
    id: "RgbSliderQuestion.targetColorSwatchLabel",
    defaultMessage: "Target color: red {r}, green {g}, blue {b}.",
    description:
      "Accessible text alternative for the target color swatch, conveying the RGB values the learner must match (the color is otherwise conveyed only visually).",
  },
  yourColorSwatchLabel: {
    id: "RgbSliderQuestion.yourColorSwatchLabel",
    defaultMessage: "Your color: red {r}, green {g}, blue {b}.",
    description:
      "Accessible text alternative for the learner's live color swatch, conveying its current RGB values (the color is otherwise conveyed only visually).",
  },
  channelRed: {
    id: "RgbSliderQuestion.channelRed",
    defaultMessage: "Red",
    description: "Name of the red color channel.",
  },
  channelGreen: {
    id: "RgbSliderQuestion.channelGreen",
    defaultMessage: "Green",
    description: "Name of the green color channel.",
  },
  channelBlue: {
    id: "RgbSliderQuestion.channelBlue",
    defaultMessage: "Blue",
    description: "Name of the blue color channel.",
  },
  channelValueLabel: {
    id: "RgbSliderQuestion.channelValueLabel",
    defaultMessage: "{channel}: <b>{value}</b>",
    description: "Label showing a channel name and its current value.",
  },
  channelAriaValueText: {
    id: "RgbSliderQuestion.channelAriaValueText",
    defaultMessage: "{value} of {max}",
    description:
      "Screen-reader text representation of a channel slider's value, combined with the channel name accessible label.",
  },
  yourColorAnnouncement: {
    id: "RgbSliderQuestion.yourColorAnnouncement",
    defaultMessage: "Your color is now red {r}, green {g}, blue {b}.",
    description:
      "Live announcement of the learner's current color for assistive technology.",
  },
  addMoreRed: {
    id: "RgbSliderQuestion.addMoreRed",
    defaultMessage: "Try adding more red.",
    description: "Directional hint to increase the red channel.",
  },
  addLessRed: {
    id: "RgbSliderQuestion.addLessRed",
    defaultMessage: "Try adding less red.",
    description: "Directional hint to decrease the red channel.",
  },
  addMoreGreen: {
    id: "RgbSliderQuestion.addMoreGreen",
    defaultMessage: "Try adding more green.",
    description: "Directional hint to increase the green channel.",
  },
  addLessGreen: {
    id: "RgbSliderQuestion.addLessGreen",
    defaultMessage: "Try adding less green.",
    description: "Directional hint to decrease the green channel.",
  },
  addMoreBlue: {
    id: "RgbSliderQuestion.addMoreBlue",
    defaultMessage: "Try adding more blue.",
    description: "Directional hint to increase the blue channel.",
  },
  addLessBlue: {
    id: "RgbSliderQuestion.addLessBlue",
    defaultMessage: "Try adding less blue.",
    description: "Directional hint to decrease the blue channel.",
  },
  successVerdict: {
    id: "RgbSliderQuestion.successVerdict",
    defaultMessage:
      "<b>Correct!</b> You have identified the correct RGB values.",
    description:
      "Verdict shown when the learner matches the target color. Followed, in the same banner, by the question's authored explanation — or by targetColorFallback when the author supplied none.",
  },
  targetColorFallback: {
    id: "RgbSliderQuestion.targetColorFallback",
    defaultMessage: "The target color is RGB({r}, {g}, {b}).",
    description:
      "Second sentence of the success feedback for a question with no authored explanation. States the target's channel values, which are otherwise conveyed only by the swatch. Prose describing a specific color belongs in the authored explanation, since it cannot be generated from arbitrary channel values.",
  },
  emptySubmitWarning: {
    id: "RgbSliderQuestion.emptySubmitWarning",
    defaultMessage: "Try moving the slider to change your color.",
    description:
      "Warning shown when the learner submits without moving a slider.",
  },
  predictionSubmitted: {
    id: "RgbSliderQuestion.predictionSubmitted",
    defaultMessage:
      "<b>Prediction submitted.</b> You will compare this answer with your final result at the end of the experiment.",
    description: "Feedback shown after a prediction is submitted.",
  },
  submitAnswer: {
    id: "RgbSliderQuestion.submitAnswer",
    defaultMessage: "Submit answer",
    description: "Label for the assessment-mode submit button.",
  },
  submitPrediction: {
    id: "RgbSliderQuestion.submitPrediction",
    defaultMessage: "Submit prediction",
    description: "Label for the prediction-mode submit button.",
  },
  resetQuestion: {
    id: "RgbSliderQuestion.resetQuestion",
    defaultMessage: "Reset question",
    description:
      "Label for the button that clears a correct answer so the learner can try the sliders again.",
  },
  resetPrediction: {
    id: "RgbSliderQuestion.resetPrediction",
    defaultMessage: "Reset prediction",
    description: "Label for the button that resets a submitted prediction.",
  },
});
